define('shoptheme/components/paypal/express/review',[
	"jquery",
	"cartware/components/_base",
	"gigaset/spinner"
], function(
	$,
	Component,
	Spinner
) {
	return Component.create({
		init: function() {
			var checkoutReviewForm = new VarienForm('order_review_form'),
				shippingMethodForm = new VarienForm('shipping_method_form');
			
			var _initialize = OrderReviewController.prototype.initialize,
				__validateForm = OrderReviewController.prototype._validateForm;

			OrderReviewController.prototype._submitOrder = function(){
				if (this._canSubmitOrder && (this.reloadByShippingSelect || this._validateForm())) {
					this.form.submit();
					this._updateOrderSubmit(true);
					this._toggleButton(this.formSubmit, true, true);
					if (this._ubpdateOrderButton) {
						this._ubpdateOrderButton.addClassName('no-checkout');
						this._ubpdateOrderButton.setStyle({opacity:.5});
					}
					// if (this._pleaseWait) {
					// 	this._pleaseWait.show();
					// }
					Spinner.add();

					return;
				}
				this._updateOrderSubmit(true);
			};

			OrderReviewController.prototype.initialize = function(orderForm, orderFormSubmit, shippingSelect, shippingSubmitForm, shippingResultId, shippingSubmit) {
				// _initialize.apply(this, arguments);

				if (!orderForm) {
					return;
				}
				this.form = orderForm;
				if (orderFormSubmit) {
					this.formSubmit = orderFormSubmit;
					var submitOrder = this._submitOrder.bind(this);
					var onSubmitButtonClick = function() {
						if (shippingMethodForm.validator.validate() && checkoutReviewForm.validator.validate()) {
							submitOrder();
						}
					};
					Event.observe(orderFormSubmit, 'click', onSubmitButtonClick);
				}

				if (shippingSubmitForm) {
					this.reloadByShippingSelect = true;
					if (shippingSubmitForm && shippingSelect) {
						this.shippingSelect = shippingSelect;
						Event.observe(
							shippingSelect,
							'change',
							this._submitShipping.bindAsEventListener(this, shippingSubmitForm.action, shippingResultId)
						);
						this._updateOrderSubmit(false);
					} else {
						this._canSubmitOrder = true;
					}
				} else {
					Form.getElements(this.form).each(this._bindElementChange, this);

					if (shippingSelect && $(shippingSelect)) {
						this.shippingSelect = $(shippingSelect).id;
						this.shippingMethodsContainer = $(this.shippingSelect).up();
					} else {
						this.shippingSelect = shippingSelect;
					}
					this._updateOrderSubmit(false);
				}

				var self = this;
				$(this.shippingSelect).change(function(e){
					self.shippingSelect.blur();
					self._submitShipping(e, shippingSubmitForm.action, shippingResultId);
				});
			};

			OrderReviewController.prototype._submitShipping = function(event, url, resultId){
				this._updateOrderSubmit(true);
				// if (this._pleaseWait) {
				// 	this._pleaseWait.show();
				// }
				if ('' != this.shippingSelect.value) {
					Spinner.add();
					new Ajax.Updater(resultId, url, {
						parameters: {isAjax:true, shipping_method:this.shippingSelect.value},
						onComplete: function() {
							// if (this._pleaseWait) {
							// 	this._pleaseWait.hide();
							// }
							Spinner.remove();
						}.bind(this),
						onSuccess: this._onSubmitShippingSuccess.bind(this),
						evalScripts: true
					});
				}
			};

			OrderReviewController.prototype._toggleButton = function(button, disable, force){
				if (force !== true) {
					return;
				}

				button.disabled = disable;
				button.removeClassName('no-checkout');
				button.setStyle({opacity:1});
				if (disable) {
					button.addClassName('no-checkout');
					button.setStyle({opacity:.5});
				}
			};

			// Moved from template
			PayPalExpressAjax = new OrderReviewController($('#order_review_form').get(0), $('#review_button').get(0),
				$('#shipping_method').get(0), $('#shipping_method_form').get(0), 'details-reload'
			);
			PayPalExpressAjax.addPleaseWait($('#review-please-wait').get(0));
		}
	});
});
